import { createSelector } from 'reselect';
import { selectors as bookmakersInfoSelectors } from '../bookmakersInfo';
import { selectors as bookmakersListSelectors } from '../bookmakersList';

const CURRENCY_TO_SIGN_DICTIONARY = {
    GBP: '£',
    EUR: '€',
    USD: '$',
};

export function createShowBalanceSelector(feedSelector) {
    return createSelector(
        [
            bookmakersInfoSelectors.bookmakersInfoSelector,
            feedSelector,
        ],
        (bookmakersInfo, feed) => {
            const config = bookmakersInfo[feed] || {};
            return (typeof config.showBalance === 'undefined') || config.showBalance;
        },
    );
}

export function createUserCurrencySelector(feedSelector) {
    return createSelector(
        bookmakersListSelectors.createUserInfoSelector(feedSelector),
        ({ hasDetails, currency }) => currency || (hasDetails !== undefined ? 'unknown' : 'GBP'),
    );
}

export function createUserCurrencySignSelector(feedSelector) {
    return createSelector(
        createUserCurrencySelector(feedSelector),
        currency => CURRENCY_TO_SIGN_DICTIONARY[currency] || '',
    );
}

export function createUserInfoSelector(feedSelector) {
    return createSelector([
        createShowBalanceSelector(feedSelector),
        createUserCurrencySelector(feedSelector),
        createUserCurrencySignSelector(feedSelector),
        bookmakersListSelectors.createUserInfoSelector(feedSelector),
    ],
        (showBalance, currency, currencySign, { hasDetails, userName, balance }) => ({
            name: userName,
            hasDetails,
            balance,
            currency,
            currencySign,
            showBalance,
        }),
    );
}



// WEBPACK FOOTER //
// /src/js/common/userInfo/userInfo.selectors.js